import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* justify-content: center;
  align-items: center; */
  font-size: 1em;
  /* padding: .5em; */
  
  height: 100%;
`;

export default Container;
